import React from 'react'

function NotFound() {
    return (
        <>
            <div className='d-flex align-items-center justify-content-center vh-100 vw-100 bg-secondary'>
                <div className="alert alert-dark p-5 shadow d-flex flex-column gap-5 align-items-center">
                    <span className='display-1'>
                        404 Not Found
                    </span>
                    <button className='btn btn-lg btn-secondary px-5' onClick={(e)=>{window.location.href="/"}}>Go Back</button>
                </div>
            </div>
        </>
    )
}

export default NotFound